/** @jsxImportSource @emotion/react */
// eslint-disable-next-line no-unused-vars
import React from "react";
import { decodeStyle, parseStyle } from "../../../junctionAbs";
import ElementWrapper from "./wrappers/ElementWrapper";

function RichText({ id, db, gs }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    let input = ps.input;

    let styles = decodeStyle(ps.style, gs);

    return (
        <ElementWrapper id={id}>
            <div
                css={{
                    columnWidth: "auto",
                    columnCount: input.columnCount,
                    ...decodeStyle(ps.fixStyle, gs),
                    ...decodeStyle(ps.style, gs),
                    "&:hover": decodeStyle(ps.hover, gs),
                    textAlign: input.textAlign,
                }}
            >
                <p>
                    Please delete this element and use new{" "}
                    <strong>Rich Text</strong> instead
                </p>
                {/* <QurealTextEditorBasic
                    id={`QQ${id}`}
                    html={input.html}
                    setHtml={handleChange}
                    onFocus={() => setSelectedElement(id)}
                    styles={styles}
                    active={selectedElement === id}
                /> */}
            </div>
        </ElementWrapper>
    );
}

export default RichText;
